import { Avatar, HStack, Icon, Text, Tooltip, VStack } from "@chakra-ui/react";
import { FiAlertTriangle } from "react-icons/fi";
import { MFMember } from "state/members/member";

type MemberLike = Pick<
  MFMember,
  "id" | "email" | "name" | "firstName" | "lastName" | "imageUrl"
> & { status?: MFMember["status"]; internal?: boolean };

const MemberIdentity = ({
  member,
  size = "sm",
  showAvatar = true,
  showEmail = true,
  emailAsNameFallback = false,
}: {
  // Nullable because service-account access-review rows reach this component
  // with no associated Member — left-join produces null on the BE side.
  member: MemberLike | null | undefined;
  size?: "sm" | "md" | "xs" | "lg" | "xl" | "2xl";
  showAvatar?: boolean;
  showEmail?: boolean;
  emailAsNameFallback?: boolean;
}) => {
  const name = member?.name ?? "";
  const email = member?.email ?? "";
  const hasName = Boolean(name.trim());
  return (
    <HStack>
      {showAvatar && (
        <Avatar
          name={name}
          size={size}
          src={member?.imageUrl ?? undefined}
          borderRadius="5px"
        />
      )}
      <VStack spacing={0} align="flex-start">
        <HStack>
          <Text
            fontWeight={hasName ? "500" : "400"}
            variant="sm.m"
            color={hasName ? "gray.700" : "gray.400"}
          >
            {emailAsNameFallback ? (hasName ? name : email) : name}
          </Text>
          {member?.status === "inactive" ? (
            <Tooltip label="Member is no longer active/employed">
              <span>
                <Icon as={FiAlertTriangle} boxSize="14px" color="orange.700" />
              </span>
            </Tooltip>
          ) : null}
        </HStack>
        {showEmail && (
          <Text
            fontSize="xs"
            color={email ? "gray.600" : "gray.400"}
            isTruncated
          >
            {email || "No email"}
          </Text>
        )}
      </VStack>
    </HStack>
  );
};

export default MemberIdentity;
